module.exports = __webpack_public_path__ + "img/architecture.96e391d7.png";